export class StrictMap<K, T> extends Map<K, T> {
  strictGet(key: K): T {
    if (!this.has(key)) throw new Error(`Missing value for ${String(key)}`);
    return this.get(key)!;
  }
}

// Просто так выполнить override метода ломает реактивность vue,
// т.к. значения пытаются проксироваться, и строгий get начниает валить приложение
